import { Stack, Button } from '@mui/material'
import React, { FC, useMemo } from 'react'
import { useModal } from '../../contexts/modal'
import palette from '../../theme/palette'
import { stackFlexRow } from '../../utils/MUIShortcuts'
import MCBase from './MCBase'

type MCAlertProps = {
  title: string | string[],
  text?: string,
  onClose?: () => void,
  buttonText?: string,
}

const h2Style: React.CSSProperties = {
  color: palette.secondary.main,
  textAlign: 'center'
}

const pStyle: React.CSSProperties = {
  color: palette.secondary.main,
  textAlign: 'center',
  margin: '24px 0'
}

const MCAlert: FC<MCAlertProps> = ({title, text, onClose, buttonText}) => {

  const { setModalOpen } = useModal()
  const realTitle: string[] = useMemo(() => {
    if(typeof title === 'string'){
      return [ title ]
    }
    return title
  }, [ title ])

  return (
    <MCBase>
      {
        realTitle.map((e, i) => <h2 style={h2Style} key={'alert_title_' + i}>{ e }</h2>)
      }
      <p style={pStyle}>{text}</p>
      <Stack {...stackFlexRow('center', 'center')} style={{width: '100%'}}>
        <Button
          variant="contained"
          onClick={() => (onClose ? onClose() : setModalOpen(false))}
          sx={{
            minWidth: 120,
            textTransform: 'none',
            fontWeight: 500,
            backgroundColor: palette.primary.main,
          }}
        >
          {buttonText ?? 'Fechar'}
        </Button>
      </Stack>
    </MCBase>
  )
}

export default MCAlert